import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventMessageDeletedDraft } from 'entities/Conversation'
import { type ConversationMenuStore } from '../store/conversationMenuStore'

export const useEventMessageDeletedDraft = (store: ConversationMenuStore) => {
  const entities = useEntitiesContext()
  const { websocket } = entities
  const handler = (data: IResponseEventMessageDeletedDraft) => {
    store.quickFiltersMenuStore.handleQuickFilterDraftCount({
      conversationId: data.conversation.id,
      isIncrease: false,
      decreaseCount: 1,
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.MessageDeletedDraft, handler), [])
}
